<template>
  <div>
    <DialogLoading
      :message="loadingMessage"
      :active="loading"
    />
      <div class="infos">
        <p><strong> Observação: </strong>O cadastro passa a ter validade após o protocolo de recebimento pela Idealiza. O preenchimento do presente cadastro não configura compromisso de compra de produto imobiliário.</p>
        <p><strong>Informações Gerais: </strong></p>
        <p>1. O cliente cadastrado receberá informações antecipadamente e terá o privilégio em eventual reserva.</p>
        <p>2. O cadastro representa a escolha por parte do cliente da imobiliária que irá representá-lo.</p>
        <p>3. Cada cliente deverá escolher somente uma imobiliária para representá-lo e preencher apenas um cadastro.</p>
        <p>4. Empreendimento com requerimento de registro imobiliário protocolado sob o nº818959 em 01/06/2026 perante o 1º Ofício e Registral Imobiliário de São José dos Campos.</p>
        <p>5. Projeto Arquitetônico aprovado pela Prefeitura Municipal de São José dos Campos-SP, pelo processo nº 106112/2025 aprovado em 22 de maio de 2026.</p>
      </div>
        <v-card>
        <v-card-text>
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
          >
            <v-row>
              <v-col cols="12" sm="6" md="2">
                <v-select
                  :items="realStateItems"
                  item-text="name"
                  item-value="id"
                  no-data-text="Sem dados"
                  label="Imobiliária"
                  :rules="obrigatoryRules"
                  v-model="client.realState"
                  disabled
                  required
                />
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-select
                  :items="brokerItems"
                  item-text="name"
                  item-value="id"
                  label="Corretor"
                  no-data-text="Sem dados"
                  :rules="obrigatoryRules"
                  v-model="client.broker"
                  required
                  :disabled="isDisabledBroker"
                />
              </v-col>
              <v-col cols="12" sm="6" md="2">
                <v-select
                  :items="[{ value: false, name: 'Pessoa Física' }, { value: true, name: 'Pessoa Jurídica' }]"
                  item-text="name"
                  item-value="value"
                  label="Tipo de Pessoa"
                  no-data-text="Sem dados"
                  v-model="juridiClient"
                  @change="onJuridiClientChange"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-select
                  :items="sizeApartments"
                  item-text="name"
                  item-value="id"
                  label="Tamanho da Sala"
                  no-data-text="Sem dados"
                  :rules="obrigatoryRules"
                  v-model="client.sizeApartment"
                  hint="Essa opção do Tamanho da Sala poderá ser alterada no momento da escolha da unidade."
                  persistent-hint
                  required
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col v-if="juridiClient" cols="12" sm="6" md="2">
                <v-text-field
                  v-mask="'##.###.###/####-##'"
                  v-model="client.cnpj"
                  :rules="cnpjRules"
                  label="CNPJ do Cliente"
                  @blur="actionsAfterCnpj"
                  required
                />
              </v-col>
              <v-col cols="12" sm="6" md="2">
                <v-text-field
                  v-mask="'###.###.###-##'"
                  v-model="client.cpf"
                  :rules="cpfRules"
                  :label=" juridiClient ? 'CPF do Representante Legal' : 'CPF do Cliente'"
                  required
                  @blur="actionsAfterCpf"
                />
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field
                  v-model="client.name"
                  :rules="obrigatoryRules"
                  maxlength="100"
                  :label=" juridiClient ? 'Razão Social' : 'Nome completo e sem abreviaturas'"
                  required
                />
              </v-col>
              <v-col cols="12" sm="6" md="2">
                <v-text-field
                  v-model="client.address.cep"
                  :label=" juridiClient ? 'CEP da Empresa' : 'CEP'"
                  :rules="obrigatoryRules"
                  required
                  @blur="getClientCep"
                />
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field
                  v-model="client.address.street"
                  :label="juridiClient ? 'Endereço da Empresa' : 'Endereço'"
                  :rules="obrigatoryRules"
                  maxlength="100"
                  required
                />
              </v-col>
              <v-col cols="12" sm="6" md="2">
                <v-text-field
                  v-model="client.address.district"
                  label="Bairro"
                  :rules="obrigatoryRules"
                  maxlength="100"
                  required
                />
              </v-col>
              <v-col cols="12" sm="6" md="1">
                <v-text-field
                  v-model="client.address.number"
                  label="Número"
                  :rules="obrigatoryRules"
                  maxlength="10"
                  type="number"
                  min="0"
                  required
                />
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field
                  v-model="client.address.complement"
                  label="Complemento"
                  maxlength="150"
                />
              </v-col>
              <v-col cols="12" sm="6" md="2">
                <v-text-field
                  label="Cidade"
                  v-model="client.address.city"
                  :rules="obrigatoryRules"
                  required
                  maxlength="100"
                />
              </v-col>
              <v-col cols="12" sm="6" md="1">
                <v-text-field
                  :rules="obrigatoryRules"
                  required
                  maxlength="2"
                  v-model="client.address.state"
                  label="Estado"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col v-if="juridiClient" cols="12" sm="6" md="3">
                <v-text-field
                  maxlength="200"
                  v-model="client.legal_representative"
                  :rules="obrigatoryRules"
                  label="Representante Legal"
                  required
                />
              </v-col>
              <v-col cols="12" sm="6" md="2">
                <v-text-field
                  :label=" juridiClient ? 'RG do Representante Legal' : 'RG do Cliente'"
                  maxlength="15"
                  v-model="client.rg"
                  :rules="obrigatoryRules"
                  required
                />
              </v-col>
              <v-col cols="12" sm="6" md="1">
                <v-text-field
                  label="Nacionalidade"
                  v-model="client.nationality"
                  :rules="obrigatoryRules"
                  required
                  maxlength="100"
                />
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field
                  label="Profissão"
                  :rules="obrigatoryRules"
                  v-model="client.profession"
                  required
                  maxlength="100"
                />
              </v-col>
              <v-col cols="12" sm="6" md="2">
                <v-text-field
                  label="E-mail"
                  :rules="emailRules"
                  required
                  maxlength="100"
                  v-model="client.email"
                />
              </v-col>
              <v-col cols="12" sm="6" md="1">
                <v-text-field
                  v-mask="'(##)'"
                  label="DDD Tel."
                  v-model="client.ddd_telephone"
                  required
                />
              </v-col>
              <v-col cols="12" sm="6" md="2">
                <v-text-field
                  v-mask="'#####-####'"
                  label="Tel. Residencial"
                  v-model="client.telephone"
                />
              </v-col>
              <v-col cols="12" sm="6" md="2">
                <v-autocomplete
                  :items="countryItems"
                  item-text="name"
                  item-value="iso"
                  label="País"
                  :rules="obrigatoryRules"
                  v-model="client.country"
                  @change="onCountryChange"
                  required
                >
                  <template v-slot:selection="data">
                    <v-avatar size="24" class="mr-2">
                      <v-img :src="data.item.flag"></v-img>
                    </v-avatar>
                    <span>{{ data.item.name }}</span>
                  </template>
                  <template v-slot:item="data">
                    <template v-if="typeof data.item !== 'object'">
                      <v-list-item-content v-text="data.item"></v-list-item-content>
                    </template>
                    <template v-else>
                      <v-list-item-avatar size="20" rounded="false">
                        <img :src="data.item.flag">
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title v-html="data.item.name"></v-list-item-title>
                      </v-list-item-content>
                    </template>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col v-if="isBrazil" cols="12" sm="6" md="1">
                <v-text-field
                  v-mask="maskDdd()"
                  label="DDD Cel."
                  :rules="obrigatoryRules"
                  v-model="client.ddd_cell"
                  required
                />
              </v-col>
              <v-col cols="12" sm="6" :md="isBrazil ? 2 : 3">
                <v-text-field
                  :key="'cell-' + client.country"
                  v-mask="maskPhone()"
                  label="Tel. Celular"
                  :rules="obrigatoryRules"
                  v-model="client.cell"
                  required
                />
              </v-col>
              <v-col cols="12" sm="6" md="3" v-if="isDocRequired">
                <v-file-input
                  v-model="client.document"
                  :label="juridiClient ? 'Anexe até 2 documentos com foto e CPF' : 'Anexo de doc. com foto e cpf do cliente (preferível CNH)'"
                  placeholder="Tipos permitidos: .png .jpg .jpeg e .pdf"
                  accept="image/png,image/jpeg,image/heic,image/heif,application/pdf"
                  required
                  :multiple="juridiClient"
                  :small-chips="juridiClient"
                  :rules="fileRules"
                ></v-file-input>
              </v-col>
              <v-col cols="12" sm="6" md="2">
                <v-select
                  :items="maritalStatusItems"
                  item-text="name"
                  item-value="id"
                  label="Estado Civil"
                  no-data-text="Sem dados"
                  :rules="obrigatoryRules"
                  v-model="client.maritalStatus"
                  required
                  @change="onMaritalStatusChange"
                />
              </v-col>
              <v-col cols="12" sm="6" md="3" v-if="hasSpouse && !juridiClient && needsConjugateData">
                <v-select
                  :items="[{ value: true, label: 'Sim' }, { value: false, label: 'Não' }]"
                  item-text="label"
                  item-value="value"
                  label="Você deseja que os dados do cônjuge sejam inseridos em contrato?"
                  no-data-text="Sem dados"
                  v-model="spouseDataInContract"
                  :rules="obrigatoryBooleanRule"
                  required
                  @change="onSpouseDataInContractChange"
                />
              </v-col>
              <v-col cols="12" sm="6" md="2" v-if="!juridiClient">
                <v-select
                  :items="[{ value: 'M', name:'Masculino' }, { value: 'F', name: 'Feminino' }]"
                  item-text="name"
                  item-value="value"
                  label="Gênero"
                  no-data-text="Sem dados"
                  :rules="obrigatoryRules"
                  v-model="client.gender"
                  required
                />
              </v-col>
            </v-row>
            <div v-if="hasSpouse && !juridiClient && needsConjugateData && clientIncludesConjugateData">
              <v-toolbar-title class="title-bold">Dados do Cônjuge</v-toolbar-title>
              <v-row>
                <v-col cols="12" sm="6" md="3">
                <v-text-field
                  v-model="client.spouse.name"
                  :rules="obrigatoryRules"
                  label="Nome"
                  maxlength="100"
                  required
                />
                </v-col>
                <v-col cols="12" sm="6" md="1">
                  <v-select
                  :items="[{ value: 'M', name:'Masculino' }, { value: 'F', name: 'Feminino' }]"
                  item-text="name"
                  item-value="value"
                  label="Gênero"
                  no-data-text="Sem dados"
                  :rules="obrigatoryRules"
                  v-model="client.spouse.gender"
                  required
                  />
                </v-col>
                <v-col cols="12" sm="6" md="2">
                <v-select
                  :items="regimeItems"
                  no-data-text="Sem dados"
                  item-text="name"
                  item-value="id"
                  label="Regime de Bens"
                  :rules="obrigatoryRules"
                  v-model="client.spouse.propertyRegime"
                  required
                />
                </v-col>
                <v-col cols="12" sm="6" md="2">
                <v-text-field
                  v-mask="'###.###.###-##'"
                  v-model="client.spouse.cpf"
                  :rules="cpfRules"
                  label="CPF"
                  required
                />
                </v-col>
                <v-col cols="12" sm="6" md="2">
                <v-text-field
                  label="RG"
                  maxlength="15"
                  v-model="client.spouse.rg"
                  :rules="obrigatoryRules"
                  required
                />
                </v-col>
                <v-col cols="12" sm="6" md="2">
                <v-text-field
                  label="Profissão"
                  v-model="client.spouse.profession"
                  :rules="obrigatoryRules"
                  maxlength="100"
                  required
                />
                </v-col>
                <v-col cols="12" sm="6" md="1">
                <v-text-field
                  :rules="obrigatoryRules"
                  v-mask="'(##)'"
                  required
                  label="DDD Celular"
                  v-model="client.spouse.ddd_cell"
                />
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <v-text-field
                    :rules="obrigatoryRules"
                    v-mask="'#####-####'"
                    required
                    label="Celular"
                    v-model="client.spouse.cell"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="1">
                  <v-switch
                    v-model="sameAddress"
                    :label="'Mesmo endereço'"
                  ></v-switch>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                <v-text-field
                  v-mask="'#####-###'"
                  v-model="client.spouse.address.cep"
                  label="CEP"
                  :rules="obrigatoryRules"
                  @blur="getClientspouseCep"
                  required
                />
                </v-col>
                <v-col cols="12" sm="6" md="3">
                <v-text-field
                  v-model="client.spouse.address.street"
                  label="Endereço"
                  :rules="obrigatoryRules"
                  maxlength="100"
                  required
                />
                </v-col>
                <v-col cols="12" sm="6" md="3">
                <v-text-field
                  v-model="client.spouse.address.district"
                  label="Bairro"
                  :rules="obrigatoryRules"
                  maxlength="100"
                  required
                />
                </v-col>
                <v-col cols="12" sm="6" md="1">
                <v-text-field
                  v-model="client.spouse.address.number"
                  label="Número"
                  :rules="obrigatoryRules"
                  maxlength="10"
                  type="number"
                  min="0"
                  required
                />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                <v-text-field
                  v-model="client.spouse.address.complement"
                  label="Complemento"
                  maxlength="100"
                />
                </v-col>
                <v-col cols="12" sm="6" md="2">
                <v-text-field
                  label="Cidade"
                  v-model="client.spouse.address.city"
                  :rules="obrigatoryRules"
                  required
                  maxlength="100"
                />
                </v-col>
                <v-col cols="12" sm="6" md="1">
                <v-text-field
                  :rules="obrigatoryRules"
                  required
                  v-model="client.spouse.address.state"
                  label="Estado"
                  maxlength="2"
                />
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <v-text-field
                    :rules="obrigatoryRules"
                    required
                    label="Nacionalidade"
                    v-model="client.spouse.nationality"
                    maxlength="100"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <v-text-field
                    :rules="emailRules"
                    required
                    label="E-mail"
                    v-model="client.spouse.email"
                    maxlength="100"
                  />
                </v-col>
              </v-row>
            </div>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="editByReserve" color="red" dark @click="cancelate">Cancelar</v-btn>
					<v-btn color="blue darken-1" :disabled="!valid" text @click="validate">Salvar</v-btn>
        </v-card-actions>
    </v-card>

     <v-dialog
      v-model="dialog"
      width="500"
    >
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Aviso
        </v-card-title>

        <v-card-text>
          Verifique se os dados do cliente estão corretos. Poderá corrigir qualquer dado incorreto ou fechar essa aba e continuar a solicitação de reserva.
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialog = false"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { isCPF, isCNPJ } from 'brazilian-values'
import DialogLoading from '@/components/loading/DialogLoading'
import viacep from '@/services/viacep'
import message from '@/utils/message'
import { normalizeFiles } from '@/utils/imageFile'
import store from '@/store'
import api from '@/services/api'
import brasil from '@/services/brasil'
import { countries } from '@/utils/countries'

export default {
  components: {
    DialogLoading
  },

  data: () => ({
    showMessageUserCreated: false,
    messageUserCreated: null,

    dialog: false,

    loading: true,
    loadingMessage: 'Carregando',

    valid: true,
    sameAddress: false,
    spouseDataInContract: false,
    juridiClient: false,
    phoneClearEnabled: false,

    verificar: {
      cnpj: null,
      ddd_cell: null,
      ddd_telephone: null,
      telephone: null
    },

    obrigatoryRules: [
      v => !!v || 'Informação obrigatória'
    ],
    emailRules: [
      v => !!v || 'Informação obrigatória',
      v => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'E-mail deve ser válido'
    ],
    cpfRules: [
      v => !!v || 'Informação obrigatória',
      v => isCPF(v) || 'CPF deve ser válido'
    ],
    cnpjRules: [
      v => !!v || 'Informação obrigatória',
      v => isCNPJ(v) || 'CNPJ deve ser válido'
    ],
    obrigatoryBooleanRule: [
      v => typeof v === 'boolean' || 'Informação obrigatória'
    ],
    modeCreate: true,
    editByReserve: false,
    maritalStatusItems: [],
    countryItems: countries,
    realStateItems: [],
    brokerItems: [],
    statusesItems: [],
    regimeItems: [],
    sizeApartments: [],
    filters: {
      status: null,
      realState: null
    },
    client: {
      id: null,
      realState: null,
      broker: null,
      name: null,
      rg: null,
      nationality: 'Brasileiro (a)',
      cpf: null,
      cnpj: null,
      address_company: null,
      legal_representative: null,
      maritalStatus: null,
      profession: null,
      ddd_telephone: null,
      telephone: null,
      country: 'BR',
      ddd_cell: null,
      cell: null,
      email: null,
      document: null,
      documentIds: [],
      status: { id: 1 },
      gender: null,
      sizeApartment: null,
      syncBySienge: false,
      address: {
        id: null,
        cep: null,
        street: null,
        district: null,
        city: null,
        state: null,
        number: null,
        complement: null
      },
      spouse: {
        id: null,
        name: null,
        rg: null,
        cpf: null,
        propertyRegime: null,
        gender: null,
        address: {
          id: null,
          cep: null,
          street: null,
          district: null,
          city: null,
          state: null,
          number: null,
          complement: null
        },
        nationality: 'Brasileiro (a)',
        profession: null,
        ddd_cell: null,
        cell: null,
        email: null
      }
    }
  }),

  computed: {
    // Em `computed` o `this` é a instância (diferente do `data`, que aqui é uma
    // arrow function e não enxerga o componente). Reage a mudanças de juridiClient.
    fileRules () {
      const isPJ = this.juridiClient
      return [
        // obrigatório
        v => {
          if (isPJ) {
            return (Array.isArray(v) && v.length > 0) || 'Informação obrigatória'
          }
          return !!v || 'Informação obrigatória'
        },
        // máximo de 2 arquivos (apenas PJ)
        v => {
          if (isPJ) {
            return (Array.isArray(v) && v.length <= 2) || 'Máximo de 2 arquivos'
          }
          return true
        },
        // tamanho de cada arquivo ≤ 5MB (vale para PF e PJ)
        v => {
          const files = Array.isArray(v) ? v : [v]
          return files.every(f => f && (f.size < 5242880 || typeof f.id !== 'undefined')) ||
            'Tamanho máximo de arquivo 5MB'
        }
      ]
    },

    filteredClientes () {
      let listClients = this.clients

      if (this.clients) {
        if (this.filters.status) {
          listClients = this.clients.filter(client => client.status.id === this.filters.status)
        }

        if (this.filters.realState) {
          listClients = listClients.filter(client => client.realState.id === this.filters.realState)
        }

        return listClients
      } else {
        return []
      }
    },

    formTitle () {
      return this.modeCreate ? 'Novo Cliente' : 'Editar Cliente'
    },

    isAdmin () {
      return store.getters.user.userType !== null && store.getters.user.userType.id === 1
    },

    isManager () {
      return store.getters.user.userType !== null && store.getters.user.userType.id === 3
    },

    isDisabledBroker () {
      if (this.isAdmin) return false
      else if (this.isManager && this.modeCreate) return false
      return true
    },

    isBrazil () {
      return this.client.country === 'BR'
    },

    hasSpouse () {
      return (this.client.maritalStatus && [2, 3].includes(this.client.maritalStatus)) || (this.client.maritalStatus && [2, 3].includes(this.client.maritalStatus.id))
    },

    isDocRequired () {
      return store.getters.config.docObrigatory !== null && store.getters.config.docObrigatory
    },

    needsConjugateData () {
      return store.getters.config.conjugateData !== null && store.getters.config.conjugateData
    },

    clientIncludesConjugateData () {
      return this.spouseDataInContract
    }
  },

  watch: {
    // 'client.maritalStatus' (newValue, _oldValue) {
    //   if (!this.modeCreate) {
    //     if ([2, 3].includes(newValue) && !this.client.spouse) {
    //       this.client.spouse = {
    //         id: null,
    //         name: null,
    //         rg: null,
    //         cpf: null,
    //         cnpj: null,
    //         address_company: null,
    //         legal_representative: null,
    //         propertyRegime: null,
    //         gender: null,
    //         address: {
    //           id: null,
    //           cep: null,
    //           street: null,
    //           district: null,
    //           city: null,
    //           state: null,
    //           number: null,
    //           complement: null
    //         },
    //         nationality: 'Brasileiro (a)',
    //         profession: null,
    //         ddd_cell: null,
    //         cell: null,
    //         email: null
    //       }
    //     }
    //   }
    // },

    sameAddress (value) {
      if (value) {
        this.client.spouse.address.cep = this.client.address.cep
        this.client.spouse.address.street = this.client.address.street
        this.client.spouse.address.district = this.client.address.district
        this.client.spouse.address.number = this.client.address.number
        this.client.spouse.address.complement = this.client.address.complement
        this.client.spouse.address.city = this.client.address.city
        this.client.spouse.address.state = this.client.address.state
      } else {
        this.client.spouse.address.cep = null
        this.client.spouse.address.street = null
        this.client.spouse.address.district = null
        this.client.spouse.address.number = null
        this.client.spouse.address.complement = null
        this.client.spouse.address.city = null
        this.client.spouse.address.state = null
      }
    }
  },

  created () {
    this.execLoad()
  },

  methods: {
    async execLoad () {
      const idClient = this.$router.history.current.params.id
      if (idClient) {
        if (this.$router.history.current.query.by) {
          this.editByReserve = true
          this.dialog = true
        }

        this.modeCreate = false
        await this.getClientById(idClient)
        this.getCnpjDDDCell()
      }

      if (!this.isAdmin) {
        this.client.realState = store.getters.user.realState
        this.filters.realState = this.client.realState.id

        if (this.modeCreate) {
          this.client.broker = store.getters.user.broker.id
        }
      }

      this.getMaritalStatus()
      this.getRealStates()
      this.getBrokers()
      this.getPropertyRegimes()
      this.getStatuses()
      this.getSizeApartments()

      this.$nextTick(() => {
        this.phoneClearEnabled = true
      })
    },

    onJuridiClientChange (newValue) {
      if (newValue) {
        this.client.document = null
        this.client.documentIds = []
      }
    },

    onCountryChange () {
      if (!this.phoneClearEnabled) {
        return
      }
      this.client.ddd_cell = null
      this.client.cell = null
    },

    onMaritalStatusChange (newValue) {
      if (![2, 3].includes(newValue)) {
        this.spouseDataInContract = false
        this.client.spouse = null
      }
    },

    onSpouseDataInContractChange (newValue) {
      if (newValue) {
        this.client.spouse = {
          id: null,
          name: null,
          rg: null,
          cpf: null,
          cnpj: null,
          address_company: null,
          legal_representative: null,
          propertyRegime: null,
          gender: null,
          address: {
            id: null,
            cep: null,
            street: null,
            district: null,
            city: null,
            state: null,
            number: null,
            complement: null
          },
          nationality: 'Brasileiro (a)',
          profession: null,
          ddd_cell: null,
          cell: null,
          email: null
        }
      } else {
        this.client.spouse = null
      }
    },

    maskDdd () {
      const country = countries.find(c => c.iso === this.client.country)
      return country ? (country.dddMask || '(##)') : '(##)'
    },

    maskPhone () {
      const country = countries.find(c => c.iso === this.client.country)
      return country ? country.mask : '#####-####'
    },

    getCnpjDDDCell () {
      this.client.cnpj = this.verificar.cnpj
      this.client.ddd_cell = this.verificar.ddd_cell
      this.client.ddd_telephone = this.verificar.ddd_telephone
      this.client.telephone = this.verificar.telephone
    },

    cancelate () {
      window.open('', '_self').close()
    },

    toListPage () {
      let timeout = 8000
      if (this.showMessageUserCreated) {
        this.loadingMessage = `${this.messageUserCreated} Direcionando você em 8 segundos para a listagem.`
      } else {
        timeout = 4000
        this.loadingMessage = 'Direcionando você em 4 segundos para a listagem.'
      }
      this.loading = true
      setTimeout(() => {
        this.loading = false
        this.$router.push({ name: 'clients' })
      }, timeout)
    },

    async getClientById (id) {
      try {
        const { data } = await api.get(`/clients/${id}`)
        this.client = data

        if (!this.client.country) {
          this.client.country = 'BR'
        }

        if (this.client.spouse) {
          this.spouseDataInContract = true

          if (this.client.address.cep === this.client.spouse.address.cep) {
            this.sameAddress = true
          }
        }

        this.verificar.cnpj = data.cnpj
        this.verificar.ddd_cell = data.ddd_cell
        this.verificar.ddd_telephone = data.ddd_telephone
        this.verificar.telephone = data.telephone

        if (this.client.cnpj) {
          this.juridiClient = true
        }

        // documentos: backend retorna um array `documents`. Popula o v-model do
        // input (array para PJ, arquivo único para PF) e os ids já persistidos.
        const documents = Array.isArray(this.client.documents) ? this.client.documents : []
        this.$set(this.client, 'documentIds', documents.map(doc => doc.id).filter(docId => typeof docId !== 'undefined'))
        this.$set(this.client, 'document', this.juridiClient ? documents : (documents[0] || null))
      } catch (error) {
        message.error('Erro ao buscar Cliente')
      } finally {
        this.loading = false
      }
    },

    async actionsAfterCnpj () {
      if (this.modeCreate && this.juridiClient) {
        if (await this.verifyCnpjVinculatedWithBroker()) {
          if (!await this.getClientSienge(this.client.cnpj)) {
            this.getInfosCnpj()
          }
        }
      }
    },

    async verifyCnpjVinculatedWithBroker () {
      try {
        this.loading = true

        if (this.modeCreate && this.client.cnpj) {
          if (!this.client.broker) {
            message.error('Selecione o corretor antes de informar o CNPJ', 'Por Favor')
            this.client.cnpj = null
            return false
          } else if (this.client.cnpj.length === 18) {
            const response = await api.get(`/clients/info?clientIdentifier=${this.client.cnpj}`)
            if (response.data && response.data.broker_id === this.client.broker) {
              message.error('CNPJ já vinculado com este corretor')
              this.client.cnpj = null
              return false
            }
            return true
          }
        }
        return false
      } catch (error) {
        message.error('Erro ao buscar cliente pelo CNPJ')
        return false
      } finally {
        this.loading = false
      }
    },

    async actionsAfterCpf () {
      if (this.modeCreate && this.client.cpf && !this.juridiClient) {
        if (await this.verifyCpfVinculatedWithBroker()) {
          this.getClientSienge(this.client.cpf)
        }
      }
    },

    async verifyCpfVinculatedWithBroker () {
      try {
        if (!this.client.broker) {
          message.error('Selecione o corretor antes de informar o CPF', 'Por Favor')
          this.client.cpf = null
          return false
        } else if (this.client.cpf.replace('-', '').length === 13) {
          this.loading = true
          const response = await api.get(`/clients/info?clientIdentifier=${this.client.cpf}`)
          if (response.data && response.data.broker_id === this.client.broker && response.data.cnpj === null) {
            message.error('CPF já vinculado com este corretor')
            this.client.cpf = null
            return false
          }
        }
        return true
      } catch (error) {
        message.error('Erro ao buscar cliente pelo CPF')
        return false
      } finally {
        this.loading = false
      }
    },

    async getClientSienge (identifier) {
      try {
        const { data } = await api.get(`/clients/${identifier.replace(/\D/g, '')}/sienge`)
        if (data) {
          this.client.syncBySienge = true
          message.success('Atualize/preencha as informações necessárias', 'Dados importados do Sienge')
          this.client.name = data.name
          this.client.rg = data.numberIdentityCard
          this.client.profession = data.profession
          this.client.email = data.email
          this.client.gender = data.sex ? data.sex[0] : null

          if (data.spouse) {
            this.client.spouse.name = data.spouse.name
            this.client.spouse.cpf = data.spouse.cpf
            this.client.spouse.email = data.spouse.email
            this.client.spouse.numberIdentityCard = data.spouse.numberIdentityCard
            this.client.spouse.gender = data.spouse.sex ? data.spouse.sex[0] : null
          }

          this.setPhonesFromSienge(data.phones)

          data.addresses.map(address => {
            if (!this.juridiClient && address.type === 'Residencial') {
              this.setAdressFromSienge(address)
            } else if (this.juridiClient && address.type === 'Comercial') {
              this.setAdressFromSienge(address)
            }
          })
          return true
        }
        this.client.syncBySienge = false
        return false
      } catch (error) {
        message.warning('Não conseguimos buscar o cliente no Sienge')
        return false
      }
    },

    async setPhonesFromSienge (phones) {
      phones.map(phone => {
        if (phone.number.charAt(1) === '0') {
          phone.number = phone.number.replace('0', '')
        }

        if (phone.type === 'Celular') {
          this.client.ddd_cell = phone.number.substring(0, 4)
          this.client.cell = phone.number.substring(4, 20)
        } else {
          this.client.ddd_telephone = phone.number.substring(0, 4)
          this.client.telephone = phone.number.substring(4, 20)
        }
      })
    },

    async setAdressFromSienge (address) {
      this.client.address.cep = address.zipCode
      this.client.address.street = address.streetName
      this.client.address.district = address.neighborhood
      this.client.address.city = address.city
      this.client.address.state = address.state
      this.client.address.number = address.number
      this.client.address.complement = address.complement
    },

    async getClientCep () {
      const searchCep = this.client.address.cep ? this.client.address.cep.replace(/\D/g, '') : ''
      if (searchCep.length === 8) {
        const data = await this.searchCep(searchCep)
        if (data) {
          this.client.address.street = data.address
          this.client.address.district = data.district
          this.client.address.city = data.city
          this.client.address.state = data.state
        }
      }
    },

    async getClientspouseCep () {
      if (this.client.spouse.address.cep && this.client.spouse.address.cep.replace('-', '').length === 8) {
        const data = await this.searchCep(this.client.spouse.address.cep.replace('-', ''))
        if (data) {
          this.client.spouse.address.street = data.address
          this.client.spouse.address.district = data.district
          this.client.spouse.address.city = data.city
          this.client.spouse.address.state = data.state
        }
      }
    },

    searchCep: async function (searchQuery) {
      const response = await viacep.get(`/${searchQuery}/json/`)
      if (response.data.erro) {
        return null
      }

      return { address: response.data.logradouro, district: response.data.bairro, city: response.data.localidade, state: response.data.uf, complement: response.data.complemento }
    },

    async getBrokers () {
      try {
        const { data } = await api.get('/users?page=-1&itemsPerPage=-1')
        this.brokerItems = data.data
      } catch (error) {
        message.error('Erro ao buscar corretores')
      } finally {
        this.loading = false
      }
    },

    async getStatuses () {
      try {
        const { data } = await api.get('/statuses')
        this.statusesItems = data
      } catch (error) {
        message.error('Erro ao buscar status')
      } finally {
        this.loading = false
      }
    },

    async getRealStates () {
      try {
        const { data } = await api.get('/real-states?page=-1&itemsPerPage=-1')
        this.realStateItems = data.data
      } catch (error) {
        message.error('Erro ao buscar imobiliárias')
      } finally {
        this.loading = false
      }
    },

    async getPropertyRegimes () {
      try {
        const { data } = await api.get('/property-regimes')
        this.regimeItems = data
      } catch (error) {
        message.error('Erro ao buscar regime de bens')
      } finally {
        this.loading = false
      }
    },

    async getMaritalStatus () {
      try {
        const { data } = await api.get('/marital-statuses')
        this.maritalStatusItems = data
      } catch (error) {
        message.error('Erro ao buscar estados civis')
      } finally {
        this.loading = false
      }
    },

    async getSizeApartments () {
      try {
        const response = await api.get(`/size-apartments`)
        this.sizeApartments = response.data
      } catch (error) {
        message.error('Erro ao buscar tamanhos de apartamentos')
      } finally {
        this.loading = false
      }
    },

    validate () {
      if (this.$refs.form.validate()) {
        this.save()
      }
    },

    async save () {
      this.loading = true
      if (this.modeCreate) {
        this.loadingMessage = 'Salvando'

        if (await this.createClientAddress()) {
          if (await this.createDocument()) {
            if (this.hasSpouse && this.clientIncludesConjugateData && !this.juridiClient) {
              if (await this.createSpouseAddress()) {
                await this.createSpouse()
              }
            }
          }

          await this.createClient()
        }
      } else {
        this.loadingMessage = 'Atualizando'

        if (this.hasSpouse && this.clientIncludesConjugateData && this.client.spouse.id) {
          await this.updateSpouse()
          await this.updateSpouseAddress()
        } else if (this.hasSpouse && this.clientIncludesConjugateData && !this.client.spouse.id && !this.juridiClient) {
          if (await this.createSpouseAddress()) {
            await this.createSpouse()
          }
        }

        if (this.isDocRequired) {
          await this.updateDocument()
        }

        await this.updateClientAddress()
        await this.updateClient()
      }

      if (this.editByReserve) {
        this.loadingMessage = 'Fechando a aba em 4 segundos para continuar a solicitação de reserva.'
        this.loading = true
        setTimeout(() => {
          this.loading = false
          return this.cancelate()
        }, 4000)
      } else {
        this.toListPage()
      }
    },

    async getClientData () {
      const data = {
        real_state_id: this.client.realState.id ? this.client.realState.id : this.client.realState,
        broker_id: this.client.broker.id ? this.client.broker.id : this.client.broker,
        name: this.client.name,
        rg: this.client.rg,
        cpf: this.client.cpf,
        cnpj: this.client.cnpj,
        address_company: this.client.address_company,
        legal_representative: this.client.legal_representative,
        nationality: this.client.nationality,
        profession: this.client.profession,
        email: this.client.email,
        country: this.client.country,
        ddd_telephone: this.client.ddd_telephone,
        telephone: this.client.telephone,
        ddd_cell: this.client.country === 'BR' ? this.client.ddd_cell : '(00)',
        cell: this.client.cell,
        marital_status_id: this.client.maritalStatus ? this.client.maritalStatus.id ? this.client.maritalStatus.id : this.client.maritalStatus : this.client.maritalStatus,
        address_id: this.client.address.id,
        spouse_id: this.client.spouse ? this.client.spouse.id : null,
        gender: this.client.gender,
        size_apartment_id: this.client.sizeApartment ? this.client.sizeApartment.id ? this.client.sizeApartment.id : this.client.sizeApartment : this.client.sizeApartment,
        syncBySienge: this.client.syncBySienge
      }

      if (this.isDocRequired) {
        data.documents = this.client.documentIds
      }

      return data
    },

    async getSpouseData () {
      return {
        name: this.client.spouse.name,
        address_id: this.client.spouse.address.id,
        property_regime_id: this.client.spouse.propertyRegime.id ? this.client.spouse.propertyRegime.id : this.client.spouse.propertyRegime,
        rg: this.client.spouse.rg,
        cpf: this.client.spouse.cpf,
        nationality: this.client.spouse.nationality,
        profession: this.client.spouse.profession,
        email: this.client.spouse.email,
        ddd_cell: this.client.spouse.ddd_cell,
        cell: this.client.spouse.cell,
        gender: this.client.spouse.gender
      }
    },

    async createClient () {
      try {
        const data = await this.getClientData()
        await api.post('/clients', data)
        message.success('Cliente salvo')
        this.showMessageUserCreated = true
        this.messageUserCreated = `Parabéns! Cliente ${this.client.name} criado. Iremos confirmar o cadastro com o documento enviado. Data: ${new Date().toLocaleString('pt')}. `
      } catch (error) {
        message.error(error.message)
        return false
      } finally {
        this.loading = false
      }
    },

    async updateClient () {
      try {
        const data = await this.getClientData()
        await api.put(`/clients/${this.client.id}`, data)
        await api.put(`clients/${this.client.id}/status`, { status_id: 1 })
        message.success('Cliente atualizado')
      } catch (error) {
        message.error(error.message)
      } finally {
        this.loading = false
      }
    },

    // Normaliza a seleção do v-file-input para array (PF single -> [file], PJ já é array).
    selectedDocuments () {
      const value = this.client.document
      if (Array.isArray(value)) {
        return value.filter(Boolean)
      }
      return value ? [value] : []
    },

    // Envia um array de arquivos e recebe um array de ids ([1] ou [1, 2]).
    async uploadDocuments (files) {
      const normalized = await normalizeFiles(files)
      const formData = new FormData()
      normalized.forEach(file => formData.append('images', file))
      formData.append('directory', 'clients')
      const response = await api.post('documents', formData)
      return response.data
    },

    async createDocument () {
      try {
        if (this.isDocRequired) {
          this.client.documentIds = await this.uploadDocuments(this.selectedDocuments())
          message.success('Documento salvo')
        }

        return true
      } catch (error) {
        message.error(error.message)
        return false
      } finally {
        this.loading = false
      }
    },

    async updateDocument () {
      try {
        if (this.isDocRequired) {
          const selection = this.selectedDocuments()
          const existingDocs = selection
            .filter(doc => doc && typeof doc.id !== 'undefined')
            // .map(doc => doc.id)
          const newFiles = selection.filter(doc => doc instanceof File)

          let uploadedDocs = []
          if (newFiles.length > 0) {
            uploadedDocs = await this.uploadDocuments(newFiles)
            message.success('Documento atualizado')
          }

          this.client.documentIds = [...existingDocs, ...uploadedDocs]
        }
        return true
      } catch (error) {
        message.error(error.message)
        return false
      } finally {
        this.loading = false
      }
    },

    async createClientAddress () {
      try {
        const response = await api.post('/addresses', await this.getAddress(this.client.address))
        message.success('Endereço do cliente salvo')
        this.client.address = response.data
        return true
      } catch (error) {
        message.error(error.message)
        return false
      } finally {
        this.loading = false
      }
    },

    async updateClientAddress () {
      try {
        const response = await api.put(`/addresses/${this.client.address.id}`, await this.getAddress(this.client.address))
        message.success('Endereço do cliente atualizado')
        this.client.address = response.data
      } catch (error) {
        message.error(error.message)
      } finally {
        this.loading = false
      }
    },

    async createSpouseAddress () {
      try {
        const response = await api.post('/addresses', await this.getAddress(this.client.spouse.address))
        this.client.spouse.address = response.data
        message.success('Endereço do cônjuge salvo')
        return true
      } catch (error) {
        message.error(error.message)
        return false
      } finally {
        this.loading = false
      }
    },

    async createSpouse () {
      try {
        const data = await this.getSpouseData()
        const response = await api.post('/spouses', data)
        this.client.spouse.id = response.data.id
        message.success('Cônjuge salvo')
        return true
      } catch (error) {
        message.error(error.message)
        return false
      } finally {
        this.loading = false
      }
    },

    async updateSpouse () {
      try {
        const data = await this.getSpouseData()
        await api.put(`/spouses/${this.client.spouse.id}`, data)
        message.success('Cônjuge atualizado')
      } catch (error) {
        message.error(error.message)
      } finally {
        this.loading = false
      }
    },

    async updateSpouseAddress () {
      try {
        const response = await api.put(`/addresses/${this.client.spouse.address.id}`, await this.getAddress(this.client.spouse.address))
        message.success('Endereço do cônjuge atualizado')
        this.client.spouse.address = response.data
        return true
      } catch (error) {
        message.error(error.message)
        return false
      } finally {
        this.loading = false
      }
    },

    async getAddress (address) {
      address.state = address.state.toUpperCase()
      return address
    },

    async getInfosCnpj () {
      try {
        message.success('Buscando dados na RF')
        const { data } = await brasil.get(`cnpj/v1/${this.client.cnpj.replace(/\D/g, '')}`)
        if (data) {
          if (!data.descricao_situacao_cadastral === 'ATIVA') {
            message.error('CNPJ inativo, não é possível cadastrar!')
            this.client.cnpj = null
            return
          }
          this.client.address.district = data.bairro
          this.client.address.city = data.municipio
          this.client.address.state = data.uf
          this.client.address.cep = data.cep.replace(/(?<=^.{5})/, '-')
          this.client.address.complement = data.complemento
          this.client.address.number = data.numero
          this.client.address.street = `${data.descricao_tipo_de_logradouro} ${data.logradouro}`
          this.client.name = data.nome_fantasia ? data.nome_fantasia : data.razao_social
        }
      } catch (error) {}
    }
  }
}
</script>

<style scoped>
  .infos {
    font-size: 11px;
    margin: 15px;
  }
  p {
    margin-bottom: 7px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/clients/FormClient.vue